module.exports = __webpack_public_path__ + "fonts/Baskerville.f4be471d.eot";